import { BreakPoints } from '../types/theme';

export const breakpoints: BreakPoints = {
  values: {
    xs: 478,
    sm: 767,
    md: 991,
    lg: 1280,
    xl: 1440,
  },
};
